import { CollaboratorsTemplate } from "../../Templates/CollaboratorsTemplate";

export const Collaborators = () => {
  return <CollaboratorsTemplate />;
};
